export default __webpack_public_path__ + "static/data-more-about-img2-6c545cf2b7bd59c3862ede92da261baf.webp";